/**
 * @file 组件传值
 * @author zhaoziwei
 */
import Vue from 'vue';
export default new Vue();
